import { useTranslation } from "react-i18next";
import { useState } from "react";
import Flag from "react-world-flags";

const flags = {
  en: "GB",
  ro: "RO",
  es: "ES",
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const currentLang = i18n.language?.split("-")[0] || "en";

  const toggleDropdown = () => setOpen(!open);
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  return (
    <div className="position-relative">
      <button
        onClick={toggleDropdown}
        style={{
          background: "transparent",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <Flag code={flags[currentLang]} style={{ width: 24, height: 16 }} />
      </button>

      {open && (
        <div
          className="position-absolute bg-white shadow"
          style={{ top: "120%", left: 0, zIndex: 999 }}
        >
          {Object.entries(flags).map(([lng, code]) =>
            lng !== currentLang ? (
              <button
                key={lng}
                onClick={() => changeLanguage(lng)}
                style={{
                  background: "transparent",
                  border: "none",
                  padding: "0.25rem",
                  cursor: "pointer",
                }}
              >
                <Flag code={code} style={{ width: 24, height: 16 }} />
              </button>
            ) : null
          )}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
